/**
 * Opt-in auth hydration diagnostics.
 *
 * Enable (any one):
 * - localStorage.setItem('smartqr_auth_debug', '1') then reload
 * - REACT_APP_AUTH_DEBUG=true at build time
 *
 * Disable:
 * - localStorage.removeItem('smartqr_auth_debug')
 *
 * Never logs tokens or passwords. No-op when the flag is off.
 */

const STORAGE_KEY = "smartqr_auth_debug";

export function isAuthDebugEnabled() {
  try {
    if (typeof process !== "undefined" && process.env?.REACT_APP_AUTH_DEBUG === "true") {
      return true;
    }
    if (typeof window !== "undefined" && window.localStorage?.getItem(STORAGE_KEY) === "1") {
      return true;
    }
  } catch {
    /* private mode / blocked storage */
  }
  return false;
}

export function authDebug(event, detail = undefined) {
  if (!isAuthDebugEnabled()) return;
  const payload = detail === undefined ? "" : detail;
  // eslint-disable-next-line no-console
  console.info(`[smartqr:auth] ${event}`, payload);
}

/** Safe summary of /auth/me for console (no secrets). */
export function summarizeMeUser(me) {
  if (!me) return null;
  const ents = me.entitlements || {};
  return {
    id: me.id,
    email: me.email,
    plan: me.subscription_plan || me.plan,
    max_variants: ents.max_variants,
    creative_qr: !!ents.creative_qr,
    export_svg: !!ents.export_svg,
    export_pdf: !!ents.export_pdf,
    advanced_analytics: !!ents.advanced_analytics,
    entitlement_keys: Object.keys(ents).length,
  };
}
